// Honest, capability-based comparison (not a competitor smear) — the messy
// spreadsheet way vs running everything in GymMart.
export type ComparisonRow = {
    spreadsheet: string;
    gymmart: string;
};

export const COMPARISON_ROWS: ComparisonRow[] = [
    {
        spreadsheet: "Member records scattered across sheets and WhatsApp",
        gymmart: "One searchable directory with full history",
    },
    {
        spreadsheet: "Manual receipts that are easy to lose track of",
        gymmart: "PDF invoices with QR codes, auto-emailed",
    },
    {
        spreadsheet: "Renewals remembered (or forgotten) by hand",
        gymmart: "Automatic expiry and renewal reminders",
    },
    {
        spreadsheet: "Money in and out tallied at month-end, if at all",
        gymmart: "Live profit & loss, revenue and expenses",
    },
    {
        spreadsheet: "Payroll calculated manually every month",
        gymmart: "One-click payroll with leave deductions",
    },
    {
        spreadsheet: "No record of who changed what",
        gymmart: "Full audit trail with role-based access",
    },
];
